import { g } from '../global-constants';

const getTrackingInfoForResult = (
	type,
	isDefaultResult,
	title,
	facets,
	searchTerm = ''
) => {
	const excludedData = searchTerm.trim()
		? {
				dataToExcludeFromWidgetUserEvent: {
					searchTerm
				}
		  }
		: {};

	return {
		element: `${
			isDefaultResult ? 'default' : 'autocomplete'
		} ${type} result`,
		elementCTA: type === g.INVENTORY && !isDefaultResult ? facets : title,
		fieldValue: title,
		result: 'text search form submitted',
		...excludedData
	};
};
export default getTrackingInfoForResult;
